import { render, staticRenderFns } from "./AddCustom.vue?vue&type=template&id=6b471de3&scoped=true"
import script from "./AddCustom.vue?vue&type=script&lang=js"
export * from "./AddCustom.vue?vue&type=script&lang=js"
import style0 from "./AddCustom.vue?vue&type=style&index=0&id=6b471de3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b471de3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b471de3')) {
      api.createRecord('6b471de3', component.options)
    } else {
      api.reload('6b471de3', component.options)
    }
    module.hot.accept("./AddCustom.vue?vue&type=template&id=6b471de3&scoped=true", function () {
      api.rerender('6b471de3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/AddCustom.vue"
export default component.exports